import React from "react";

const Loader = () => {
  return (
    <div className="w-100 d-flex justify-content-center align-items-center text-center ">
      <div class="loader"></div>
    </div>
  );
};

export default Loader;
